import { Facebook, GitHub, LinkedIn, Instagram } from '@material-ui/icons';
import React from 'react'
import styled from 'styled-components';
import Particle from '../Components/Particles';


function HomePage() {
    return (
        <HomePageStyled>
            <div className="p-particles-js">
                <Particle id="tsparticles" url="http://foo.bar/particles.json" />
            </div>
            <div className="typography">
                <h2>Hey there!<span> I'm Om</span>
                </h2>
                <b>
                    Looking for SDE intern roles, and likes to participate in coding competitions and hackathons. Hit me up for collaborations 🎉
                </b>
                <div className="icons">
                    <a href="https://github.com/pandeyom331" target="__blank" className="icon i-github">
                        <GitHub />
                    </a>
                    <a href="https://www.linkedin.com/in/om-anand-pandey-85612b1ab/" target="__blank" className=" icon i-facebook">
                        <LinkedIn />
                    </a>
                    <a href="https://www.instagram.com/solo_thinker_134/" target="__blank" className=" icon i-instagram">
                        <Instagram />
                    </a>
                    <a href="https://www.facebook.com/people/%C3%93%E1%B9%83-Anand-Pandey/100004398076666/" target="__blank" className=" icon i-facebook">
                        <Facebook />
                    </a>

                </div>
            </div>
        </HomePageStyled>
    )
}

const HomePageStyled = styled.header`
width: 100%;
height: 100vh;
position: relative;

.p-particles-js{
    position: absolute;
    top:0;
    left:0;
    z-index:-30;
}

.typography::before{
            background: rgba(0,0,0,.9);
            content: "";
            position: absolute;
            top:0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            opacity: 0.9;
        }

.typography{
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width:80%;

    .icons{
        display: flex;
        justify-content: center;
        margin-top:1rem ;
        .icon
        {
            border:2px solid var(--border-color);
            display: flex;
            align-items: center;
            justify-content: center;
            padding:1rem;
            border-radius:50%;
            transition: all .4s ease-in-out;
            cursor:pointer;
            &:hover{
                border:2px solid var(--primary-color);
                color:var(--primary-color);
            }
            &:not(:last-child)
            {
                margin-right: 1rem;
            }
        }
        .i-instagram{
            &:hover{
                border:2px solid red;
                color:red;
            }
        }
        .i-github{
            &:hover{
                border:2px solid gray;
                color: white;
            }
        }
    }
}
`;

export default HomePage;
